module.exports = __webpack_public_path__ + "img/edit_crop.6f7b82c.svg";